// Konfiguracja stałych silnika
export const GRID_SIZE = 20; // Rozmiar kratki w px
export const WALL_THICKNESS = 16; // Domyślna grubość ściany
export const SNAP_THRESHOLD = 15; // Odległość przyciągania w px

export const TOOLS = {
  SELECT: 'SELECT',
  WALL: 'WALL',
  ROOM: 'ROOM',
  SURFACE: 'SURFACE',
  NODE: 'NODE', 
  TEXT: 'TEXT',
  TABLE: 'TABLE',
  SHAPE: 'SHAPE',
  STAIRS: 'STAIRS',
  NORTH_ARROW: 'NORTH_ARROW',
  DIMENSION_LINE: 'DIMENSION_LINE',
  DOOR: 'DOOR',
  WINDOW: 'WINDOW',
  FURNITURE: 'FURNITURE',
  OPENINGS: 'OPENINGS', // Nowy stan dla katalogu otworów
  LAYERS: 'LAYERS',
  MOVE: 'MOVE',
  ZOOM: 'ZOOM'
};

export const ELEMENT_TYPES = {
  DOOR: 'DOOR',
  DOUBLE_DOOR: 'DOUBLE_DOOR',
  SLIDING_DOOR: 'SLIDING_DOOR',
  GARAGE_DOOR: 'GARAGE_DOOR',
  WINDOW: 'WINDOW',
  OPENING: 'OPENING'
};

export const KEYBOARD_KEYS = {
  ESCAPE: 'Escape',
  DELETE: 'Delete',
  ENTER: 'Enter',
  Z: 'z',
  Y: 'y'
};

export const HATCH_PATTERNS = {
  NONE: 'None',
  DIAGONAL_45: 'Diagonal 45°',
  DIAGONAL_135: 'Diagonal 135°',
  CROSSHATCH: 'Crosshatch',
  GRID: 'Grid',
  DOTTED: 'Dotted',
  BRICK: 'Brick Pattern',
  CONCRETE: 'Concrete Pattern',
  SAND: 'Sand / Gravel Pattern',
  WOOD: 'Wood Grain Pattern',
  STEEL: 'Steel / Metal Pattern'
};